"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateSearchQuerySchema = exports.CandidateIdPathParamsSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
// Path params
exports.CandidateIdPathParamsSchema = zod_1.z.object({ candidateId: schemas_1.UUIDSchema });
// Query params - Candidate search
exports.CandidateSearchQuerySchema = schemas_1.PaginationQuerySchema.extend({
    ageMax: zod_1.z.number().optional(),
    ageMin: zod_1.z.number().optional(),
    educationLevel: zod_1.z.string().optional(),
    experienceYearsMax: zod_1.z.number().optional(),
    experienceYearsMin: zod_1.z.number().optional(),
    industryIds: zod_1.z.array(schemas_1.UUIDSchema).optional(),
    keyword: zod_1.z.string().optional(),
    languageSkills: zod_1.z.array(zod_1.z.string()).optional(),
    locationIds: zod_1.z.array(schemas_1.UUIDSchema).optional(),
    occupationIds: zod_1.z.array(schemas_1.UUIDSchema).optional(),
    salaryMax: zod_1.z.number().optional(),
    salaryMin: zod_1.z.number().optional(),
});
